export default __webpack_public_path__ + "static/media/017_photo.1718fbac.jpg";